const translations = {
  "en": {
    "Crypto": "Crypto",
    "Paypal": "Paypal"
  },
  "zh-tw": {
    "Crypto": "加密貨幣",
    "Paypal": "Paypal"
  }
};

export default translations;
